import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-requirements',
  standalone: true,
  imports: [],
  templateUrl: './process-requirements.component.html',
  styles: ``
})
export class ProcessRequirementsComponent {
  @Input() process!: Process;
}
